var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center h-100 px-1 py-3"},[_c('img',{staticClass:"position-absolute",staticStyle:{"transform":"translate(0%, 5%)"},attrs:{"src":require('@/assets/img/last_screen/' +  _vm.textVariables.welcome.last_screen),"top":"50%","left":"50%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }